/**
 * Marketing / attribution query parameters that ad traffic carries.
 *
 * These are: (a) captured into sessionStorage on entry for analytics (e.g. GTM), (b) stripped from
 * canonical URLs so a campaign-tagged landing page never indexes as a duplicate, and (c) `utm_campaign`
 * specifically also drives landing variant selection (see {@link resolveLandingVariant}).
 */
export const MARKETING_QUERY_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'fbclid',
];
//# sourceMappingURL=marketingQueryParams.js.map